import React, { useState } from 'react';
import { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import BtnEtage from '../Maquette/BtnEtage';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { JoyrideComponent } from './JoyrideComponent';

const steps = [
  {
    target: '.button-aide-maquette',
    content: 'Affichage de l’aide',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.palette-control-maquette',
    content: 'Rotation, Déplacement, Zoom, et options de la maquette',
    placement: 'top',
    disableBeacon: true,
  },
];

const keyLocalStorage = 'iframe-joyride-maquette-lot';

export function JoyrideMaquetteLot() {
  const [stepIndex, setStepIndex] = useState(0);
  const [run, setRun] = useState(
    localStorage.getItem(keyLocalStorage)
      ? localStorage.getItem(keyLocalStorage) === true
      : true,
  );

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setStepIndex(0);
      setRun(false);
      localStorage.setItem(keyLocalStorage, false);
    }
  };

  return (
    <>
      <JoyrideComponent
        run={run}
        handleJoyrideCallback={handleJoyrideCallback}
        stepIndex={stepIndex}
        steps={steps}
      />

      <BtnEtage
        className="button-aide-maquette"
        sx={{
          position: 'absolute',
          right: [18, 18, 18, 25],
          bottom: [75, 25],
          zIndex: 10,
        }}
        onClick={() => setRun(!run)}
      >
        <InfoOutlinedIcon sx={{ fontSize: '2rem', color: 'primary.main' }} />
      </BtnEtage>
    </>
  );
}
